import React from 'react';

const KeseruanBazaarIIT2024: React.FC = () => {
    return (
        <div className="text-justify py-4">
          <p className="mb-6">
            <b>Bazaar IIT Challenge 2024</b> yang meriah! Para peserta dan pengunjung disambut dengan aneka hidangan menggoda dari berbagai vendor makanan yang hadir.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🍢 Jajanan Favorit Anak Muda</h2>
          <p className="mb-6">
            <b>Gwonppang x Sweetart</b> menyajikan camilan populer seperti Gwon Ppang (kue koin), Snow Ice, Bakso Goreng, dan Popcorn. Di sisi lain, <b>STEAKEN CHICK</b> menghadirkan steak ayam, nasi sapi iris, dan hotdog yang siap mengenyangkan.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🍜 Cita Rasa Lokal</h2>
          <p className="mb-6">
            Untuk pencinta kuliner khas Nusantara, <b>Waroeng X52</b> menawarkan siomay, batagor, telur gulung, gado-gado, ketoprak, hingga nasi ayam geprek dan rujak buah. Sementara itu, <b>Pempek Pindang Acu</b> hadir dengan pempek, tekwan, dan mie celor.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🧀 Hidangan Kekinian</h2>
          <p className="mb-6">
            <b>Milfood</b> memanjakan lidah dengan rice mentai, macaroni cheese, nugget, dan pancake durian. <b>3S</b> juga tak kalah menarik dengan ropang, sosis goreng, keripik pisang, pisang bakar, hingga nasi ayam crispy dan nasi bogem.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🥣 Makanan Hangat dan Comfort Food</h2>
          <p className="mb-6">
            <b>N&apos;D LIO</b> hadir dengan pilihan rice bowl ayam bawang dan ayam bakar ketumbar, dilengkapi risol sayur dan risol beef mayo. <b>Kedai Jajan Snacksa</b> juga menyajikan jajanan seperti bakso Malang, mochi, jasuke, dan crepes yang cocok dinikmati sore hari.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🍧 Minuman Segar & Penutup</h2>
          <p className="mb-6">
            <b>Jelly Koe</b> menyegarkan suasana dengan ice jelly, silky drink, jelly sedot, dan jelly cups. Tak ketinggalan, <b>Snack Ida</b> menyuguhkan aneka kue basah, pastel, bakwan goreng, arem-arem, wonton chilli oil, dan bakpau goreng.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🤝 Booth Edukatif</h2>
          <p className="mb-6">
            Tak hanya kuliner, bazaar juga diisi oleh <b>STAR007, Manulife Agency</b> yang memberikan edukasi seputar perencanaan keuangan dan perlindungan asuransi. Sebuah nilai tambah yang memperkaya pengalaman pengunjung.
          </p>
      
          <h2 className="text-2xl font-bold mb-4 mt-6">🎉 Perpaduan Kuliner dan Teknologi</h2>
          <p className="mb-6">
            Bazaar di IIT Challenge 2024 membuktikan bahwa teknologi dan kuliner bisa bersatu dalam satu ruang penuh semangat dan kreativitas. Dari booth makanan hingga edukasi, setiap sudut menjadi tempat bertemunya inspirasi dan rasa.
          </p>
      
          <p>
            <b>Sudah coba semua menunya? Bagikan pengalamanmu dan temukan kelezatannya di setiap gigitan!</b>
          </p>
        </div>
      );
      
};

export default KeseruanBazaarIIT2024;